import Vue from "vue";
import LoadingComponent from "@erp/shared/components/ui/Unclassified/LoadingModalComponent.vue";
import vuetify from "@erp/shared/plugins/vuetify";
const LoadingConstructor = Vue.extend(LoadingComponent);
let loadingInstance = null;
/** 로딩 모달을 표시한다. 이미 표시 중이면 먼저 제거 후 새로 생성한다. */
export function showLoading(hideOverlay = false) {
    hideLoading();
    if (!Vue || !Vue.prototype.$vuetify) {
        console.warn("Vue 또는 Vuetify 인스턴스가 초기화되지 않았습니다.");
    }
    loadingInstance = new LoadingConstructor({
        vuetify,
        propsData: { dialogValue: true, hideOverlay },
    });
    loadingInstance.$mount();
    document.body.appendChild(loadingInstance.$el);
}
/** 로딩 모달을 제거한다. */
export function hideLoading() {
    if (loadingInstance) {
        try {
            document.body.removeChild(loadingInstance.$el);
            loadingInstance.$destroy();
        }
        catch (e) {
            console.warn("Loading 컴포넌트 제거 중 오류:", e);
        }
        loadingInstance = null;
    }
}
